// extracted by mini-css-extract-plugin
module.exports = {"base":"Message_base__1WIIQ","success":"Message_success__2oSlJ","error":"Message_error__1vuni","warning":"Message_warning__2poJl"};